import React, { createContext, type ReactNode } from "react";
import { useAuth } from "@/hooks/api";
import type { User } from "@/types";

interface AuthContextType {
  user: User | null | undefined;
  isLoading: boolean;
  isError: boolean;
  isAuthenticated: boolean;
  stytchLogin: (sessionToken: string, sessionJwt?: string) => Promise<unknown>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
